import React from 'react';

export const HomeFooterElasticLogo = () => {
  return (
    <svg
      className="guideHome__footerLogo"
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="19"
      fill="none"
      viewBox="0 0 60 19">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M18.83 9.99a3.682 3.682 0 00-2.451-3.472c.064-.33.098-.661.098-1.006 0-2.914-2.386-5.285-5.32-5.285a5.321 5.321 0 00-4.31 2.192 2.826 2.826 0 00-1.728-.587 2.817 2.817 0 00-2.824 2.805c0 .342.061.67.176.978C1.007 6.14.001 7.542.001 9.1c0 1.576.983 2.953 2.462 3.483a5.323 5.323 0 00-.097 1.004c0 2.908 2.381 5.273 5.308 5.273 1.718 0 3.31-.82 4.307-2.201a2.81 2.81 0 001.73.6c1.558 0 2.825-1.26 2.825-2.806 0-.342-.062-.67-.177-.978 1.464-.524 2.47-1.928 2.47-3.486z"
        clipRule="evenodd"
      />
      <path
        fill="#FEC514"
        fillRule="evenodd"
        d="M7.402 8.251l4.12 1.866L15.68 6.5c.06-.299.09-.597.09-.908 0-2.546-2.085-4.617-4.647-4.617-1.533 0-2.963.75-3.833 2.007L6.6 6.545l.803 1.706z"
        clipRule="evenodd"
      />
      <path
        fill="#00BFB3"
        fillRule="evenodd"
        d="M3.138 12.586a4.67 4.67 0 00-.091.921c0 2.553 2.09 4.63 4.66 4.63a4.653 4.653 0 003.85-2.028l.687-3.552-.916-1.738-4.136-1.873-4.054 3.64z"
        clipRule="evenodd"
      />
      <path
        fill="#F04E98"
        fillRule="evenodd"
        d="M3.112 5.502l2.823.662.619-3.189a2.239 2.239 0 00-1.352-.453 2.22 2.22 0 00-2.09 2.98z"
        clipRule="evenodd"
      />
      <path
        fill="#1BA9F5"
        fillRule="evenodd"
        d="M2.867 6.17A3.126 3.126 0 00.728 9.108c0 1.287.801 2.436 2.003 2.89l3.962-3.557-.728-1.544-3.098-.727z"
        clipRule="evenodd"
      />
      <path
        fill="#91C73E"
        fillRule="evenodd"
        d="M12.282 16.109a2.221 2.221 0 003.435-2.522l-2.821-.656-.614 3.178z"
        clipRule="evenodd"
      />
      <path
        fill="#07C"
        fillRule="evenodd"
        d="M12.856 12.196l3.105.722a3.124 3.124 0 002.14-2.938 3.089 3.089 0 00-2.008-2.886L12.03 10.63l.825 1.566z"
        clipRule="evenodd"
      />
      <path
        className="guideHome__footerLogoText"
        fillRule="evenodd"
        d="M34.054 13.714c-.763 0-1.144-.459-1.144-1.376 0-.42.1-.738.301-.957.2-.22.527-.35.979-.39l2.227-.209v2.468l-.346.12a6.117 6.117 0 01-2.017.344zm3.492-.655V9.287c0-.827-.193-1.436-.58-1.825-.386-.388-1.006-.583-1.858-.583h-2.891v.99l2.966-.003c.381 0 .682.11.903.33.22.218.331.582.331 1.09v.644l-2.363.224c-.793.08-1.375.292-1.746.636-.372.344-.557.88-.557 1.608 0 .727.18 1.286.542 1.675.36.388.888.583 1.58.583.904 0 1.806-.162 2.709-.56.342.328.882.322 1.537.315l.306-.002.058-.991s-.937.014-.937-.36zm2.766-4.041c0-.758.547-1.137 1.64-1.137.39 0 .879.03 1.452.064.374.022.783.047 1.224.067v-.978s-2.124-.155-2.736-.155c-.773 0-1.417.175-1.934.524-.517.349-.775.887-.775 1.615s.185 1.226.557 1.495c.37.27.998.474 1.881.613.883.14 1.455.287 1.716.442.261.154.392.448.392.882s-.154.743-.46.927c-.306.185-.75.277-1.331.277-.565 0-1.392-.08-2.529-.189l-.11-.01-.06.972s2.076.229 2.699.229c.953 0 1.678-.18 2.174-.539.497-.359.746-.922.746-1.69 0-.767-.186-1.29-.557-1.57-.372-.279-1.004-.495-1.897-.65-.893-.155-1.465-.304-1.716-.449-.25-.144-.376-.391-.376-.74zM47.909 8h2.394v-.972h-2.394V4.74h-1.114v2.29h-1.068V8h1.068v3.933c0 1.067.15 1.79.452 2.168.301.38.843.569 1.626.569.35 0 .863-.055 1.535-.165l-.075-.927-1.34.09c-.472 0-.77-.135-.896-.404-.125-.27-.188-.832-.188-1.69V8.001zm5.092 6.597h-1.129v-7.57h1.129v7.57zm0-8.525h-1.129v-1.3h1.129v1.3zm6.576.986c-.793-.12-1.355-.18-1.686-.18-1.124 0-1.927.287-2.408.86-.482.574-.723 1.57-.723 2.991 0 1.42.223 2.43.67 3.028.446.599 1.257.898 2.431.898.462 0 1.159-.07 2.092-.21l-.045-.927-1.776.135c-.903 0-1.498-.215-1.784-.643-.286-.429-.429-1.19-.429-2.28 0-1.093.153-1.84.46-2.244.305-.404.885-.606 1.738-.606.381 0 .973.045 1.776.135l.045-.912-.36-.045zm-30.27 7.54h1.13V4.754h-1.13v9.843zm-2.703-4.265c0-.917-.148-1.565-.444-1.944-.296-.38-.778-.569-1.445-.569s-1.169.2-1.505.599c-.337.398-.51 1.037-.52 1.914h3.914zm.407 3.245l.436-.045.03.883c-1.144.159-2.122.239-2.935.239-1.084 0-1.852-.312-2.303-.935-.451-.623-.678-1.593-.678-2.909 0-2.622 1.05-3.933 3.146-3.933 1.014 0 1.772.282 2.274.845.501.564.752 1.448.752 2.655l-.06.852h-4.967c0 .828.15 1.44.451 1.84.301.398.826.598 1.573.598.748 0 1.508-.03 2.28-.09z"
        clipRule="evenodd"
      />
    </svg>
  );
};
